export default __webpack_public_path__ + "static/DanCohen-f01d3666406496dbc5ef2689cf5a08b7.png";